
import React from 'react'
import './style.css'
import Menu from '../../components/menu'


import { makeStyles } from '@material-ui/core/styles';

import Paper from '@material-ui/core/Paper';

const tileData = [

  {
    stack: "JavaScript",
    framework: "Node - Express - React - Redux - Angular - Adonis",
    colorBg:"yellow"
  },
  {
    stack: "Python",
    framework: "Django - Flask - Pandas - numpy - scikit-learn - TensoFlow - Keras Request - beautifulsoup",
    colorBg:"blue"
  
  },

  {
    stack: "Banco de Dados ",
    framework: "Sqlite3 -  Postgre - Firebase -  Mongoose",
    colorBg:"green"

  },
  {
    stack: "Cloud",
    framework: "Google Cloud - Heroku - Netlify - Firebase" 

  },
  {
    stack: "Diferenciais ",
    framework: "Metodologias Ágeis - Git, github - Jira - Bitbucket - Confluence  ",
    colorBg:"#F4DFBD"


  },
  {
    stack: "Apresentações",
    framework: "Acessibilidade na web - Criando sua primeira aplicação Django - Conheci o minimalismo e agora? ",
    colorBg:"#F4DFBD"

  }
]

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    overflow: 'hidden',
    backgroundColor: theme.palette.background.paper,
  },
  gridList: {
    width: 500,
    height: 450,
  },
}));
const Stack = () => {
  const classes_2 = useStyles()
  return (
    <div className=" tam-tela">
      <Menu />

      <div className="container ">

        <h1>Stack</h1>
        <p>Essas são algumas das linguagens, bibliotecas, frameworks e metodologias que tenho mais experiência </p>
    <div className="container">

      <div className="row" >
        {
          tileData.map( x =>{
            return(
          <div className="col-sm-4" >
            <Paper className="style-grid" >
              <h1>{x.stack}</h1>
            <p>{x.framework}</p>
            
            </Paper>
          </div>
          )})
        }
        </div>
         
    </div>
      </div>
    </div>
  )
};

export default Stack
